/**
 * First-touch UTM capture stored in sessionStorage.
 *
 * Rules:
 * - Read UTM params on first pageview of the session.
 * - Do NOT overwrite an existing UTM set with an empty new load.
 * - Store landing_page = pathname + search only on first pageview.
 * - sessionStorage only (no cookies, no localStorage).
 */
const KEY = "goc_utm";

const UTM_FIELDS = [
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_content",
  "utm_term",
];

const readStored = () => {
  try {
    const raw = sessionStorage.getItem(KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

const writeStored = (obj) => {
  try {
    sessionStorage.setItem(KEY, JSON.stringify(obj));
  } catch {
    /* storage unavailable — silently ignore */
  }
};

export const captureAttribution = () => {
  if (typeof window === "undefined") return;
  const params = new URLSearchParams(window.location.search);
  const incoming = {};
  UTM_FIELDS.forEach((k) => {
    const v = params.get(k);
    if (v) incoming[k] = v.slice(0, 500);
  });

  const existing = readStored() || {};
  const hasAnyIncomingUtm = UTM_FIELDS.some((k) => incoming[k]);

  // First-touch: never overwrite existing UTMs with empty ones.
  const merged = {
    ...existing,
    ...(hasAnyIncomingUtm ? incoming : {}),
  };

  // landing_page is captured once per session (first pageview).
  if (!existing.landing_page) {
    merged.landing_page = (
      window.location.pathname + window.location.search
    ).slice(0, 500);
  }

  writeStored(merged);
};

export const getAttribution = () => {
  const stored = readStored() || {};
  const out = {};
  UTM_FIELDS.forEach((k) => {
    if (stored[k]) out[k] = stored[k];
  });
  if (stored.landing_page) out.landing_page = stored.landing_page;
  return out;
};
